import request from '@/router/axios';

export const getList = (params) => {
    return request({
        url: '/api/produce/device-parameter-threshold/select/page',
        method: 'post',
        params
    })
}
// 查询设备管理列表
export const getDeviceList = (params) => {
  return request({
    url: '/api/produce/base-device-manage/select/page',
    method: 'post',
    params
  })
}
export const getDetail = (id) => {
    return request({
        url: '/api/produce/device-parameter-threshold/select/id',
        method: 'get',
        params: {
            id
        }
    })
}
export const add = (row) => {
    return request({
        url: '/api/produce/device-parameter-threshold/insert',
        method: 'post',
        data: row
    })
}
export const update = (row) => {
    return request({
        url: '/api/produce/device-parameter-threshold/update',
        method: 'post',
        data: row
    })
}

export const remove = (id) => {
    return request({
        url: "/api/produce/device-parameter-threshold/delete/id",
        method: "get",
        params: {
            id
        }
    });
};

// PLC数据模拟
export const simulatePlcData = (data) => {
    return request({
        url: '/api/produce/device-monitor/monitor-and-alert',
        method: 'post',
        data
    });
};
